import { createFileRoute } from "@tanstack/react-router";
import { MainSidebar } from "../../components/sidebars/MainSidebar";
import { StudentAccessPage } from "./-StudentAccessPage";

function StudentAccessPageWithSidebar() {
  return (
    <div className="flex h-screen">
      <MainSidebar />
      <div className="flex-1 overflow-auto">
        <StudentAccessPage />
      </div>
    </div>
  );
}

export const Route = createFileRoute("/admin/access")({
  component: StudentAccessPageWithSidebar,
});
